import React from "react";
import corporateIcon from "../../assets/svgs/corporate_icon.svg";
import {useIntl} from "react-intl";
import classNames from "classnames";
import {HomeContentId, HomeContentScrollClass, HomeContentScrollContainer} from "./variable/HomeContentType";
import whiteLogoImage from "../../assets/svgs/sitebunny_logo_white.svg";
import {scrollToElement} from "../../util/animateScroll";

const HomeFooter: React.FC = () => {
    const intl = useIntl();

    const onClickLogo = () => {
        const element = document.querySelector(`#${HomeContentId.HERO}`);
        const scrollContainer = document.querySelector(`#${HomeContentScrollContainer}`)!;
        element && scrollToElement(element, scrollContainer);
    }

    return (
        <div className={classNames(HomeContentScrollClass, "bg-bunny-primary-900 min-h-[224px] pt-[39px] pb-[36px] px-[78px]")}>
            <div className="flex flex-wrap gap-y-[24px] gap-x-[64px]">
                <button className="flex items-center space-x-[12px] w-[128px] h-[28px]" onClick={onClickLogo}>
                    <img src={whiteLogoImage} alt="logo" width={28} height={28}/>
                    <h1 className="text-[18px] font-bold text-[#FFFFFF] font-pretendard"> SiteBunny </h1>
                </button>
                <div className={"flex flex-col gap-y-[32px]"}>
                    <div className={"flex gap-x-[69px] text-[#FFFFFF] text-[14px] flex-wrap gap-y-[12px]"}>
                        <a className={"cursor-pointer"} href="/terms-of-service" target={'_blank'} rel="noreferrer">
                            {intl.formatMessage({id: "i0044"})}
                        </a>
                        <a className={"cursor-pointer"} href="/privacy-policy" target={'_blank'} rel="noreferrer">
                            {intl.formatMessage({id: "i0045"})}
                        </a>
                    </div>
                    <div className={"flex flex-col gap-y-[10px] text-[#FFFFFF] text-[12px]"}>
                        <div className={"flex gap-x-[16px] flex-wrap gap-y-[12px]"}>
                            <div>{intl.formatMessage({id: "i0046"})}</div>
                            <div>{intl.formatMessage({id: "i0047"})}</div>
                            <div>{intl.formatMessage({id: "i0048"})}</div>
                        </div>
                        <div className={"flex gap-x-[16px] flex-wrap gap-y-[12px]"}>
                            <div>{intl.formatMessage({id: "i0049"})}</div>
                            <div>{intl.formatMessage({id: "i0050"})}</div>
                        </div>
                    </div>
                    <div className={"text-[#7258A7] text-[12px] flex gap-x-[5px] pt-[16px] border-t border-[#7258A7]"}>
                        <img src={corporateIcon} alt="corporate" width={14} height={14}/>
                        <div>{intl.formatMessage({id: "i0051"})}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeFooter;
